import debounce from "lodash.debounce";

const navigateCarouselToElement = (el: HTMLElement): Promise<void> => {
  return new Promise((resolve) => {
    // Find the carousel slide (swiper-slide) that contains this element
    const carouselSlide = el.closest(".swiper-slide");
    if (!carouselSlide) {
      resolve();
      return;
    }

    // Find the carousel container (swiper element)
    const swiperContainer = carouselSlide.closest(".swiper.carousel-items");
    if (!swiperContainer) {
      resolve();
      return;
    }

    // Get all slides in this carousel
    const allSlides = Array.from(
      swiperContainer.querySelectorAll(".swiper-slide"),
    );
    const slideIndex = allSlides.indexOf(carouselSlide as Element);

    if (slideIndex === -1) {
      resolve();
      return;
    }

    // Access the Swiper instance
    // Swiper stores its instance on the DOM element as 'swiper'
    const swiperInstance = (swiperContainer as any).swiper;
    if (!swiperInstance) {
      resolve();
      return;
    }

    // Navigate to the slide
    // Use slideTo with speed parameter for smooth transition
    swiperInstance.slideTo(slideIndex, 500);

    // Wait for the transition to complete
    setTimeout(() => {
      resolve();
    }, 250); // Slightly longer than the transition time
  });
};

const navigateTabToElement = (el: HTMLElement): Promise<void> => {
  return new Promise((resolve) => {
    // Find the tabs combo that contains this element
    const tabsCombo = el.closest("[data-combo-name='Tabs']");
    if (!tabsCombo) {
      resolve();
      return;
    }

    let title: Element | null = null;

    // Check if the element itself is a title
    if (el.classList.contains("tab-title-ieQiMEq5gGUGXro")) {
      title = el;
    } else {
      // Find the set (tab content) that contains the element
      const set = el.closest('[data-layer-type="set"]');
      if (!set) {
        resolve();
        return;
      }

      // Get the tab index from the set
      const idx = set.getAttribute("data-set-index");
      if (!idx) {
        resolve();
        return;
      }

      // Find the corresponding title by index
      const titles = tabsCombo.querySelectorAll(".tab-title-ieQiMEq5gGUGXro");
      title = titles[Number(idx)];
    }

    // Click the title's first child (the actual clickable button)
    if (title?.firstElementChild instanceof HTMLElement) {
      title.firstElementChild.click();
    }

    // Wait for the tab switch animation
    setTimeout(() => {
      resolve();
    }, 250);
  });
};

export const scrollToEntity = debounce(async (id?: string) => {
  if (!id) return;
  const el: HTMLDivElement | null = document.querySelector(
    `#content-sgKecQsAYKy7MX4 [data-layer-id="${id}"]`,
  );

  if (!el) return;

  // First, navigate the carousel if the element is inside one
  const isInsideCarousel = el.closest('[data-combo-name="Carousel"]');
  if (isInsideCarousel) await navigateCarouselToElement(el);

  // Navigate to the correct tab if the element is inside one
  const isInsideTabs = el.closest('[data-combo-name="Tabs"]');
  if (isInsideTabs) await navigateTabToElement(el);

  const type = el?.getAttribute("data-layer-type");
  const position = type === "slide" ? "top" : "center";
  const modifier = type === "slide" ? 117 : 155;

  const rect = el.getBoundingClientRect();
  const yCoordinate =
    window.scrollY + rect.top + (position === "center" ? rect.height / 2 : 0);
  window.scrollTo({
    top:
      yCoordinate - (position === "center" ? window.innerHeight / 2 : modifier),
    behavior: "smooth",
  });
}, 500);
